import React from 'react';
import DashboardModal from '../../../../common/DashboardModal';
import DashboardButton from '../../../../common/DashboardButton';
import { Box } from '@mui/material';

/**
 * Base dialog component for settings dialogs
 * 
 * @param {boolean} open - Whether the dialog is open
 * @param {function} onClose - Function to call when closing the dialog
 * @param {string} title - Dialog title
 * @param {string} description - Dialog description
 * @param {function} onSave - Function to call when saving changes
 * @param {node} children - Dialog content
 * @param {boolean} saveDisabled - Whether the save button should be disabled
 */
const SettingsDialogBase = ({
  open,
  onClose,
  title,
  description,
  onSave,
  children,
  saveDisabled = false,
}) => {
  return (
    <DashboardModal
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      size="md"
      fullWidth
      actions={
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', width: '100%' }}>
          <DashboardButton
            variant="outlined"
            color="primary"
            onClick={onClose}
          >
            Cancel
          </DashboardButton>
          <DashboardButton
            variant="contained"
            color="primary"
            onClick={onSave}
            disabled={saveDisabled}
          >
            Save Changes
          </DashboardButton>
        </Box>
      }
    >
      {children}
    </DashboardModal>
  );
};

export default SettingsDialogBase;